import api from "./client";

// lotAllocationIds verilmezse onayın tamamı ters alınır (mevcut davranış).
export async function reverseOperationApproval(approvalId, reason, lotAllocationIds = []) {
  const res = await api.post(`/reversal/operation-approvals/${approvalId}`, {
    reason,
    ...(lotAllocationIds.length ? { lot_allocation_ids: lotAllocationIds } : {}),
  });
  return res.data.data;
}

export async function getApprovalAuditLog(approvalType, approvalId) {
  const res = await api.get(`/reversal/audit/${approvalType}/${approvalId}`);
  return res.data.data;
}
